export default "__VITE_ASSET__D1Rn3UmV__"